
export const unitAbbreviations: { [key: string]: string } = {
  // Length
  meter: "m",
  kilometer: "km",
  centimeter: "cm",
  mile: "mi",
  yard: "yd",
  foot: "ft",
  inch: "in",
  "nautical mile": "nmi",
  fathom: "ftm",
  cable: "cb",
  ell: "ell",
  rod: "rd",
  furlong: "fur",
  league: "lea",
  cubit: "cbt",
  "roman foot": "pes",
  span: "spn",
  palm: "plm",
  chain: "ch",
  "length morgen": "mrg",
  "length hide": "hid",

  // Weight
  kilogram: "kg",
  milligram: "mg",
  pound: "lb",
  ounce: "oz",
  gram: "g",
  ton: "t",
  carat: "ct",
  grain: "gr",
  stone: "st",
  dram: "dr",
  talent: "tal",
  shekel: "shkl",

  // Volume
  liter: "L",
  milliliter: "mL",
  "fluid ounce": "fl oz",
  gallon: "gal",
  "cubic meter": "m³",
  quart: "qt",
  pint: "pt",
  gill: "gi",
  hogshead: "hhd",
  firkin: "fir",
  butt: "but",
  bushel: "bu",
  peck: "pk",
  pottle: "pot",

  // Temperature
  celsius: "°C",
  fahrenheit: "°F",
  kelvin: "K",
  reaumur: "°Ré",
  rankine: "°R",

  // Time
  second: "s",
  minute: "min",
  hour: "h",
  day: "d",
  week: "wk",
  month: "mo",
  year: "yr",
  fortnight: "fn",
  moment: "mom",
  jiffy: "jif",

  // Area
  "square meter": "m²",
  acre: "ac",
  hectare: "ha",
  "square kilometer": "km²",
  "square mile": "mi²",
  barn: "b",
  "area morgen": "mrg",
  "area hide": "hid",

  // Speed
  "meters per second": "m/s",
  "miles per hour": "mph",
  "kilometers per hour": "km/h",
  knot: "kn",
  "furlong per fortnight": "fur/fn"
};
